module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "home-dashboard"
    }
  }, [_c('div', {
    staticClass: "teamup-upsell"
  }, [_c('h1', [_vm._v("Are you looking for a game development team?")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/Browse/Developers?seeking=true"
    }
  }, [_vm._v("View Available Developers")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/Browse/Games?seeking=true"
    }
  }, [_vm._v("View Recruiting Game Projects")])], 1)]), _vm._v(" "), _c('top-content'), _vm._v(" "), ((!_vm.isLoggedIn && _vm.gotInitialLoggedUserInfo) || !_vm.hasLoginCookies) ? _c('pitch', {
    attrs: {
      "depth": "both"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69c5d2be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/HomeDashboard/HomeDashboard.vue
// module id = 884
// module chunks = 2